import { useState, useEffect } from 'react';
import API from "../providers/api";
import mdParser from "../utils/parser"

export default (titulo) => {
  const [articulo, setArticulo] = useState(null);
  const [isBusy, setIsBusy] = useState(true);

  useEffect(() => {
    const fetchArticulo = async () => {
      setIsBusy(true);
      const config = {
        params: {
          limit: 1
        }
      }
      if (titulo) config.params.titulo = titulo.toLowerCase().replace(/ /g, '_')
      else config.params.random = true

      let res
      try {
        res = await API.get("articulos", config);
      } catch (err) {
        setIsBusy(false);
        setArticulo(null)
        return
      }

      if (res?.status !== 200) {
        setIsBusy(false);
        setArticulo(null)
      }

      const data = Array.isArray(res.data) ? res.data[0] : res.data
      const parsed = data.contenido ? mdParser.parse(data.contenido) : ''

      console.log(data)
      setArticulo({
        ...data,
        html: parsed,
      } || [])
      setIsBusy(false);
    };

    fetchArticulo()
  }, [titulo]);

  return {articulo, isBusy};
}